<template>
  <el-container>
    <el-main style="background:#f8fdff;">
      <div class="body">
          <div class="loginbox">
            <p class="title">管理系统</p>
            <el-row>
              <el-col id="tips" :span="16" v-show="dis">
                <el-alert :title="errormsg" :type="msgtype" :closable="false"></el-alert>
              </el-col>
              <el-col :span="24">
                <el-form id="loginfrom" ref="form" :model="form">
                  <div class="inputbox">
                    <el-row>
                      <el-col :span="3">
                        <img src="../assets/imgs/user.png"/>
                      </el-col>
                      <el-col :span="17">
                        <input v-model="form.username" placeholder="用户名"/>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="inputbox">
                    <el-row>
                      <el-col :span="3">
                        <img src="../assets/imgs/pwd.png"/>
                      </el-col>
                      <el-col :span="17">
                        <input type="password" v-model="form.password" placeholder="密码" show-password/>
                      </el-col>
                    </el-row>
                  </div>
                  <!-- <div class="inputbox">
                    <el-row>
                      <el-col :span="3">
                        <img src="../assets/imgs/safe.png"/>
                      </el-col>
                      <el-col :span="17">
                        <input v-model="form.code" maxlength="4" placeholder="验证码"/>
                      </el-col>
                      <el-col :span="4">
                        <div @click="changeCode()" id="codechange">
                          <identify :identifyCode="identifyCode"></identify>
                        </div>
                      </el-col>
                    </el-row>
                  </div> -->
                  <el-button class="loginbtn" @click="onSubmit">立即登录</el-button>
                  <!-- <a id="wxbtn">微信扫码登录</a> -->
                </el-form>
              </el-col>
            </el-row>
          </div>
      </div>
    </el-main>
    <el-footer id="footer">
      <div class="footernav">
        <a href="http://beian.miit.gov.cn/">版权所有 © 2003-2022 All rights reserved.粤ICP备2022039058号</a>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import identify from '@/components/common/identify.vue'
import {login} from "@/api/login"
export default {
  name: 'login',
  components: { identify },
  data(){
    return {
      action:'login',
      form: {
        username: '',
        password:'',
        code:''
      },
      // 验证码初始值
      identifyCode: '',
      // 验证码的随机取值范围
      identifyCodes: '123456789QAZWSXEDCRFVTGBYHNUJMIKLP',
      dis:false,
      errormsg:'',
      msgtype:'error',
    }
  },
  mounted() {
    this.identifyCode = ''
    var vcode = this.getParam('vcode');
    if(vcode){
      var lang = this.getParam('lang'), username = this.getParam('username');
      sessionStorage.setItem('token', vcode) //保存服务器返回的token
      sessionStorage.setItem('mname', username)
      window.localStorage.setItem("lang", lang)
      this.$router.push('/home/index')
    }
    this.makeCode(this.identifyCodes, 4)
  },
  created() {
    var that = this;
    document.onkeydown = function() {
    var key = window.event.keyCode;
      if (key == 13 && that.$route.path.length<3) {
        that.onSubmit();
      }
    }
  },
  methods:{
    getParam(paramName) {
      var paramValue = "", isFound = !1, arrSource,i,url = window.location.hash.replace('#/','');
      if (url.indexOf("?") == 0 && url.indexOf("=") > 1) { 
          arrSource = unescape(url).substring(1, url.length).split("&"), i = 0;
          while (i < arrSource.length && !isFound) arrSource[i].indexOf("=") > 0 && arrSource[i].split("=")[0].toLowerCase() == paramName.toLowerCase() && (paramValue = arrSource[i].split("=")[1], isFound = !0), i++ 
      } 
      return paramValue == "" && (paramValue = null), paramValue 
    },
    onSubmit() {
      var data = this.form;
      if(data.username==''){
        this.errormsg = '请填写用户名！';
        this.dis = true;
        return false;
      }
      if(data.password==''){
        this.errormsg = '请填写密码！';
        this.dis = true;
        return false;
      }
      // if(data.code==''){
      //   this.errormsg = '请填写验证码！';
      //   this.dis = true;
      //   return false;
      // }
      // if(data.code.toLowerCase()!=this.identifyCode.toLowerCase()){
      //   this.errormsg = '请填写正确的验证码！';
      //   this.dis = true;
      //   return false;
      // }
      const loading = this.$loading({ lock: true, text: 'loading', spinner: 'el-icon-loading' });
      login({
          username: data.username,
          password: data.password,
          source:'pc'
      }).then(res=>{
        setTimeout(() => { loading.close() }, 0);
        if(res.data.code===1){
          this.errormsg = '';
          this.dis = false;
          sessionStorage.setItem('token', res.data.data.vcode)
          sessionStorage.setItem('name', res.data.data.name)
          sessionStorage.setItem('roleid', res.data.data.roleid)
          sessionStorage.setItem('company', res.data.data.company)
          sessionStorage.setItem('address', res.data.data.address)
          sessionStorage.setItem('contacts', res.data.data.contacts)
          this.$router.push('/home/statistics')
        }else if(res.data.code===1010){
          this.mustLogin(res.data.message)
        }else{
          this.$message.error(res.data.message);
        }
      }).catch(err=>{
        setTimeout(() => { loading.close() }, 0);
        this.$message.error(err);
      })
    },
    mustLogin(message){
      this.$confirm(message, '提示', {
        confirmButtonText: '继续登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onSubmit()
      }).catch(() => {
        this.errormsg = '';
        this.dis = false;
        this.$message({
          type: 'info',
          message: '已取消'
        });          
      });
    },
    // 点击验证码刷新验证码
    changeCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    // 生成一个随机整数  randomNum(0, 10) 0 到 10 的随机整数， 包含 0 和 10
    randomNum (min, max) {
      max = max + 1
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 随机生成验证码字符串
    makeCode (data, len) {
      for (let i = 0; i < len; i++) {
        this.identifyCode += data[this.randomNum(0, data.length - 1)]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.body{
  width:500px;
  overflow: hidden;
  margin:8% auto 0;
  padding: 1em 0;
}
.loginbox{
  background: #fff;
  padding:1em;
  border-radius: 0.8em;
  box-shadow: 0 0 1em 0.1em rgb(21,147,203,0.1);
}
.loginbox .logo{
  width: 12em;
  margin: 2em auto;
  display: block;
}
.loginbox .title{
  color:#b7babd;
  font-size: 1em;
  font-weight: bold;
  text-align: center;
  margin: 1em 0 2em;
}
.inputbox{
  position: relative;
}
#codechange{
  position: absolute;
  right:1em;
}
.loginbox .inputbox img{
  width: 1.2em;
  height: 1.2em;
  display: inline;
  margin-right: 2em;
  float: left;
  margin-top: 0.7em;
}
.inputbox input{
  font-size: 0.8em;
  border:none;
  padding: 0.1em 1em;
  border-bottom: 1px solid #cbcbcb;
  line-height: 2em;
  height: 3em;
  margin-bottom: 2em;
  outline:none;
  width:100%;
}
.loginbtn{
  width: 14em;
  color:#fff;
  background: #2874ce;
  border-radius: 2em;
  margin: 1em auto;
  display: block;
}
#wxbtn{
  display: block;
  color:#2874ce;
  text-align: center;
  margin-top: 3em;
  font-size: 0.8em;
  font-weight: bold;
}
#footer{
  background: #fff;
  height: auto!Important;
}
.footernav{
  width:1200px;
  margin:0 auto;
  padding:1em 0;
  overflow: hidden;
  text-align: center;
}
.footernav a {
  color:#b7babd;
  text-decoration: none;
  text-align: center;
  margin:0 auto;
}
.left{
  float: left;
}
.right{
  float: right;
}
.footertop{
  color: #989898;
  line-height: 2em;
}
.footertop a{
  font-size: 0.6em;
  display: inline;
}
.footertop em{
  display: inline;
  margin:0 1em;
}
.footerbottom{
  color: #989898;
  line-height: 2em;
}
.footerbottom span{
  display: inline;
  margin:0 1em;
  font-size: 0.6em;
}
#loginfrom{
  margin:0 auto;
  width:16em;
  min-width: 14em;
  max-width:30em;
}
#forgetpwd{
  color:#111;
  text-decoration: none;
  float: right;
}
#tips{
  float:none;
  margin: 1em auto;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue